module.exports = __webpack_public_path__ + "img/good_vibes_good_life.6e4281d3.jpg";